export type AnyObjectType = {
  [key: string]: unknown;
};

export const hasObjectsHaveProps = (...objs: Array<AnyObjectType | undefined>): boolean => {
  return objs.some((obj) => obj && Object.keys(obj).length > 0);
};
